export function addressToBytes32(addr: string): string {
  const stripped = addr.replace(/^0x/, '');
  return '0x' + stripped.padStart(64, '0');
}
